export default __webpack_public_path__ + "static/media/item3.f6a1de03.png";